function prepareAttributes(): MutationBodyAttributes {
  return {
    enabled: true
  };
}

function testInstanceRelationship(testInstanceId: number): MutationBodyRelationships {
  return {
    testInstance: {
      data: { id: `/api/v2/test-instances/${testInstanceId}`, type: 'TestInstance' }
    }
  };
}

function preparePatchRelationships(testInstanceId: number): MutationBodyRelationships {
  return {
    ...(testInstanceId ? testInstanceRelationship(testInstanceId) : {})
  };
}

function preparePostRelationships(
  testInstanceId: number,
  customerUserId?: number,
  onBoardUUID?: string
): MutationBodyRelationships {
  return {
    ...(testInstanceId ? testInstanceRelationship(testInstanceId) : {}),
    ...(customerUserId
      ? {
          user: {
            data: {
              id: `/api/v2/customers-users/${customerUserId}`,
              type: 'CustomersUsers'
            }
          }
        }
      : {}),
    ...(onBoardUUID
      ? {
          obfuscatedData: {
            data: {
              id: `/api/v2/obfuscated-datas/${onBoardUUID}`,
              type: 'ObfuscatedData'
            }
          }
        }
      : {})
  };
}

export function preparePatchTestInstanceUser(
  testInstanceId: number,
  usersTestInstancesId: number
): PatchMutationBody {
  return {
    data: {
      type: 'UsersTestInstances',
      id: `/api/v2/users-test-instances/${usersTestInstancesId}`,
      attributes: prepareAttributes(),
      ...(testInstanceId
        ? {
            /**
             * PATCH shouldn't be altering the customerUserId at all as it's the same CustomersUsers
             * the result is for. It should only be changing the TestInstance id as all we are doing
             * is assigning a response to a different TestInstance. We are not changing the user the
             * response is assigned to.
             */
            relationships: preparePatchRelationships(testInstanceId)
          }
        : {})
    }
  };
}

export function preparePostTestInstanceUser(
  testInstanceId: number,
  customerUserId: number,
  onBoardUUID?: string
): PostMutationBody {
  return {
    data: {
      type: 'UsersTestInstances',
      attributes: prepareAttributes(),
      ...(testInstanceId || customerUserId || onBoardUUID
        ? {
            relationships: preparePostRelationships(testInstanceId, customerUserId, onBoardUUID)
          }
        : {})
    }
  };
}
